module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.4@core-js/library/modules/_add-to-unscopables.js
// module id = 75
// module chunks = 0